import BaseModelAPI from '../BaseModelAPI';

export default class ActivityStateList extends BaseModelAPI {

	static entity = 'activitystatelist'
	static entityName = 'activitystate';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
